import AccessoryCommon from "./accessoryCommon";
import {createParentPositions} from "../../constants";
import {Shower} from "../../parts/shower";
import {IS_QKB_UI} from "../../../../../config";

export default class ShampooShelf extends AccessoryCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'shampoo_shelf';
    this.partName = 'Shampoo Shelf';
    this.translateId = "visualizer.bathroom.accessories.shampoo_shelf";
    this.visible = true;
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  navigationSubItems(...props) {
    if (IS_QKB_UI) {
      return this.navigationSubItemsSimple(...props)
    }
    return super.navigationSubItems(...props);
  }

  handleClick() { // "this" is feature!! not the feature group
    super.handleClick();
    const parent = this.getParent();
    const accessoriesParent = parent.getParent();
    const showerParent = accessoriesParent.layout.parts[Shower.id];
    const showerSize = showerParent.showerSize();
    if (showerSize !== "60" && parent.activeFeature) {
      parent.layerPositions[parent.activeFeature.metaData["layerPosition"]] = parent.activeFeature;
    }
    // parent.checkRelatedFeatureGroupPositions(this.metaData["layerPosition"]);
  }

  checkCenterGrabWall(clickedPosition) { // L or R and C can't be together
    if (!clickedPosition) {
      return
    }
    Object.keys(this.layerPositions).forEach(position => {
      if (clickedPosition === "C") {
        if (position !== "C") {
          this.layerPositions[position] = null;
        }
      } else if (position === "C") {
        this.layerPositions[position] = null;
      }
    })
  }

  showLayerPositionsModal(forFeature) {
    const showerParent = this.getParent().layout.parts[Shower.id];
    if (showerParent.showerSize() !== "60") {
      return false
    }
    return super.showLayerPositionsModal(forFeature)
  }

}
